'use strict'

export default class UrlUtils {
    static init() {
        let href = window.location.href;
        const url = document.createElement('a');
        href = href.replace(window.location.origin,'');
        href = href.replace('/','');
        href = href.replace('?','/');
        if (href === '') {
            href = 'home';
        }
        url.href = href;
        this.analyze(href);
    }
    static analyze(url) {
        window.staticEvents.emit('navigate',url);
    }
    static setUrl(url) {
        history.pushState('','',url);
        UrlUtils.setTitle(url);
    }
    static setTitle(url) {
        let title = 'Dr. Peter Schlötter - ';
        const urlsplit = url.split('/');
        // first character is always '/', therefore we start checking with the second
        switch (urlsplit[1]) {
            case 'home':
                title += 'Startseite';
                break;
            case 'about':
                {
                    if (urlsplit[2] === '3') {
                        title += 'O-Töne';
                    } else {
                        title += 'Vita';
                    }
                }
                break;
            case 'methods':
                {
                    if (urlsplit[2] === '1') {
                        title += 'Kommunikations-Tacho';
                    } else {
                        title += 'Das Spiel ohne Ball im Unternehmen';
                    }
                }
                break;
            case 'research':
                {
                    if (urlsplit[2] === '1') {
                        title += 'Forschung';
                    } else if (urlsplit[2] === '2') {
                        title += 'KIT';
                    } else if (urlsplit[2] === '3') {
                        title += 'Uni S';
                    }
                }
                break;
            case 'contact':
                title += 'Kontakt';
                break;
        }
        document.title = title;
    }
}
